/** @jsx isolateComponent */
import { Fragment } from 'react';
import { css } from '@emotion/core';

import TrialWelcomeModalHeader from '@zapier/design-system-company/src/components/TrialWelcomeModalHeader';
import List from '@zapier/design-system-company/src/components/List';
import {
  Button,
  Heading,
  Link,
  Margin,
  Spacer,
  Text,
} from '@zapier/design-system';
import { isolateComponent } from '@zapier/common-utils';
import { Size } from '@zapier/design-system-company/src/ts-types';

import TrialWelcomeModalTopicLink from './TrialWelcomeModalTopicLink';
import topics from '../topics';

type Props = {
  /** Callback to be executed when the modal is closed */
  onClose: () => void;
  /** Call to change modal route */
  onRoute: (s: string) => void;
  /** Size */
  size: Size;
};

const topicLinksWrapper = css`
  & > * {
    margin-bottom: 10px;
  }
`;

const heading = css`
  padding: 44px 0;
  text-align: center;
`;

const gettingStarted = css`
  display: flex;
  flex-direction: column;
`;

const buttonWrapper = css`
  display: flex;
  justify-content: center;
`;

const TrialWelcomeModalGuideView = (props: Props) => (
  <Fragment>
    <TrialWelcomeModalHeader>
      <div css={heading}>
        <Heading>
          <Text color="white" type="subtitle900">
            Getting started with Zapier for Companies
          </Text>
        </Heading>
        <Spacer height={8} />
        <Text color="white" type="bodyText900">
          Select an option below to continue setup
        </Text>
      </div>
    </TrialWelcomeModalHeader>

    <Margin margin="30px 0">
      <Margin margin={`0 ${props.size === 'small' ? '20px' : '80px'}`}>
        <div css={topicLinksWrapper}>
          <List
            gap={5}
            itemRenderer={item => (
              <TrialWelcomeModalTopicLink
                onClick={() => props.onRoute(item.id)} // +2 because default page is 0 and Guide page is 1
                text={item.title}
              />
            )}
            items={topics}
          />
        </div>
      </Margin>

      <Spacer height={30} />

      <Margin margin={`0 ${props.size === 'small' ? '20px' : '80px'}`}>
        <div css={gettingStarted}>
          <Text textAlign="center" type="subtitle800">
            Want to speak to someone?
          </Text>
          <Text textAlign="center">
            Need help navigating Zapier for Companies? We’re here to help!
          </Text>
          <Spacer height={10} />
          <div css={buttonWrapper}>
            <Button
              href="https://go.zapier.com/companies-demo-request/?demo_source=trialmodal"
              target="_blank"
            >
              Schedule a call
            </Button>
          </div>
        </div>
      </Margin>

      <Spacer height={30} />

      <Text color="grey700" tag="p" textAlign="center" type="altText900">
        New to Zapier?{' '}
        <Link
          color="grey700"
          href="/learn/getting-started-guide"
          onClick={props.onClose}
        >
          Read our Getting Started guide.
        </Link>
      </Text>
    </Margin>
  </Fragment>
);

export default TrialWelcomeModalGuideView;
